function getCharacters(string) {
  return string.split("");
}

function mapToHankaku(character) {
  let zenHanMap = getZenkakuToHankakuMap();
  if (typeof zenHanMap[character] === "undefined") {
    return character;
  } else {
    return zenHanMap[character];
  }
}

function getZenkakuToHankakuMap() {
  let zenHanMap = {
    ァ: "ｧ",
    ア: "ｱ",
    ィ: "ｨ",
    イ: "ｲ",
    ゥ: "ｩ",
    ウ: "ｳ",
    ェ: "ｪ",
    エ: "ｴ",
    ォ: "ｫ",
    オ: "ｵ",
    カ: "ｶ",
    ガ: "ｶﾞ",
    キ: "ｷ",
    ギ: "ｷﾞ",
    ク: "ｸ",
    グ: "ｸﾞ",
    ケ: "ｹ",
    ゲ: "ｹﾞ",
    コ: "ｺ",
    ゴ: "ｺﾞ",
    サ: "ｻ",
    ザ: "ｻﾞ",
    シ: "ｼ",
    ジ: "ｼﾞ",
    ス: "ｽ",
    ズ: "ｽﾞ",
    セ: "ｾ",
    ゼ: "ｾﾞ",
    ソ: "ｿ",
    ゾ: "ｿﾞ",
    タ: "ﾀ",
    ダ: "ﾀﾞ",
    チ: "ﾁ",
    ヂ: "ﾁﾞ",
    ッ: "ｯ",
    ツ: "ﾂ",
    ヅ: "ﾂﾞ",
    テ: "ﾃ",
    デ: "ﾃﾞ",
    ト: "ﾄ",
    ド: "ﾄﾞ",
    ナ: "ﾅ",
    ニ: "ﾆ",
    ヌ: "ﾇ",
    ネ: "ﾈ",
    ノ: "ﾉ",
    ハ: "ﾊ",
    バ: "ﾊﾞ",
    パ: "ﾊﾟ",
    ヒ: "ﾋ",
    ビ: "ﾋﾞ",
    ピ: "ﾋﾟ",
    フ: "ﾌ",
    ブ: "ﾌﾞ",
    プ: "ﾌﾟ",
    ヘ: "ﾍ",
    ベ: "ﾍﾞ",
    ペ: "ﾍﾟ",
    ホ: "ﾎ",
    ボ: "ﾎﾞ",
    ポ: "ﾎﾟ",
    マ: "ﾏ",
    ミ: "ﾐ",
    ム: "ﾑ",
    メ: "ﾒ",
    モ: "ﾓ",
    ャ: "ｬ",
    ヤ: "ﾔ",
    ュ: "ｭ",
    ユ: "ﾕ",
    ョ: "ｮ",
    ヨ: "ﾖ",
    ラ: "ﾗ",
    リ: "ﾘ",
    ル: "ﾙ",
    レ: "ﾚ",
    ロ: "ﾛ",
    ヮ: "",
    ワ: "ﾜ",
    // 'ヰ': 'ﾞ  ﾟ',
    // 'ヱ': '',
    ヲ: "ｦ",
    ン: "ﾝ",
    ヴ: "ｳﾞ",
    // 'ヵ': '',
    // 'ヶ': '',
    // 'ヷ': '',
    // 'ヸ': '',
    // 'ヹ': '',
    // 'ヺ': '',
    "・": "･",
    ー: "ｰ",
    // 'ヽ': '',
    // 'ヾ': '',
    // 'ヿ': '',
  };
  return zenHanMap;
}
/**
 * Function convert text to Half With
 * @param  string
 * Author Team CBA
 * Date: 09/04/2023
 */
const convertToHalfWidth = (string) => {
  let characters = getCharacters(string);
  let halfWidthString = "";
  characters.forEach((character) => {
    halfWidthString += mapToHankaku(character);
  });
  return halfWidthString;
}

export default convertToHalfWidth;

function convertVal(_val) {
  _val = _val + "";
  if (_val != "") {
    /*if(_val.length > 3){
      _val = parseInt(_val).toLocaleString('ja-JP');
    }*/
  }
  return _val;
}
/**
 * Function convert Half
 * @param  obj
 * @param  event
 * Author Team CBA
 * Date: 09/04/2023
 */

export function convertHalf(obj, event) {
  if (obj.val() == "") {
    return;
  }
  if (event.which >= 37 && event.which <= 40) {
    return false;
  }
  var input_tem = obj.val().replace(/[Ａ-Ｚａ-ｚ０-９ー－＠]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });

  //input_tem = parseInt(input_tem);
  if (!/^[0-9]+$/.test(input_tem)) {
    return;
  }
  var inp_val = convertVal(input_tem);
  var start = obj[0].selectionStart,
    end = obj[0].selectionEnd;

  obj.val(inp_val);

  obj[0].setSelectionRange(start, end);
}
